import { useContext } from "react"
import { ShowingContext } from "../../contexts/ShowingContext"

export const useShowingContext = () => {
    return useContext(ShowingContext);
}